export default __webpack_public_path__ + "static/media/InstrumentSerif-Regular.5b7bae35.ttf";